import { gql } from '@apollo/client';

const GET_DASHBOARD_CATALOG = gql`
  query($id: String!, $benefitId: String!) {
    getDashboardCatalog(id: $id, benefitId: $benefitId) {
      benefit {
        id
        benefit_info
      }
      catalog_id
      items {
        id
        title
        subtitle
        count_description
        price
        product_code
        tags
        search_rank
        type
        image_url
      }
    }
  }
`;

export default GET_DASHBOARD_CATALOG;
